import type { VoidComponent, VoidProps } from "solid-js";

const Radio: VoidComponent<VoidProps> = () => (
  // In Figma this component is designed with a border, but technically this is not possible. So we have to hijack the
  // color and use an arbitrary value.
  // oxlint-disable-next-line better-tailwindcss/no-restricted-classes
  <div class="text-(--border-color-default) group-checked:icon-brand">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.75"
        y="0.75"
        width="10.5"
        height="10.5"
        rx="5.25"
        fill="white"
        stroke="currentColor"
        stroke-width="1.5"
      />

      <rect x="2" y="2" width="8" height="8" rx="4" fill="currentColor" class="hidden group-checked:inline" />
    </svg>
  </div>
);

export default Radio;
